// extracted by mini-css-extract-plugin
export default {"container":"applicationSection_container__qNNo2"};